module.exports = __webpack_public_path__ + "static/sec8-bg-sm-c43701a1173949979a7b1f9d01f0072b.jpg";